import { createThemeLocalization } from '@planitgeo/treeplotter-i18n';
import useLocales from './useLocales';

const ThemeLocalization = createThemeLocalization(useLocales);

export default ThemeLocalization;
